import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles({
  "@keyframes spinnerSvgAnimation": {
    "100%": {
      transform: "rotate(360deg)",
    },
  },
  "@keyframes spinnerPathAnimation": {
    "0%": {
      strokeDasharray: "1, 200",
      strokeDashoffset: 0,
    },
    "50%": {
      strokeDasharray: "89, 200",
      strokeDashoffset: -35,
    },
    "100%": {
      strokeDasharray: "89, 200",
      strokeDashoffset: -124,
    },
  },
  spinner: {
    animation: "$spinnerSvgAnimation 2s linear infinite",
  },
  spinnerInsideLoadingModal: {
    height: "50px",
    top: "30%",
    left: "30%",
    position: "absolute",
    width: "50px",
  },
  circle: {
    strokeDasharray: "1, 200",
    strokeDashoffset: 0,
    animation: "$spinnerPathAnimation 1.5s ease-in-out infinite, color 6s ease-in-out infinite",
    strokeLinecap: "round",
    stroke: "#3f88f8",
  },
});

interface LoadingSpinnerComponentProps {
  isInsideLoadingModal?: boolean;
}

const LoadingSpinnerComponent: React.FC<LoadingSpinnerComponentProps> = ({
  isInsideLoadingModal,
}) => {
  const classes = useStyles();
  return (
    <svg
      className={clsx(classes.spinner, {
        [classes.spinnerInsideLoadingModal]: isInsideLoadingModal,
      })}
      height="50"
      width="50"
    >
      <circle
        className={classes.circle}
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="6"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default LoadingSpinnerComponent;
